import { type ReactNode } from 'react';

interface TopbarProps {
  title:     string;
  subtitle?: ReactNode;
  actions?:  ReactNode;
}

/**
 * Topbar sticky frosted CTO-FRONT-002.
 * À utiliser au début de chaque page (équivalent du Header v1, design pixel-perfect).
 * Référence : design-dashboard-finance-v1.html lignes 206-280.
 */
export const Topbar = ({ title, subtitle, actions }: TopbarProps) => (
  <header className="ds-topbar">
    <div>
      <div className="ds-tb-title">{title}</div>
      {subtitle && <div className="ds-tb-sub">{subtitle}</div>}
    </div>
    {actions && <div className="ds-tb-right">{actions}</div>}
  </header>
);
